import { RefObject, useEffect } from 'react';
import { noop } from 'lodash';

import { ALERT_TABS_ID } from '../consts';

export enum ObserverId {
	AlertsScreen
}

const ObserverOptions = {
	[ObserverId.AlertsScreen]: {
		threshold: 0.1,
		root: document.getElementById(ALERT_TABS_ID)
	}
};

const observers: Record<string | number, IntersectionObserver> = {};

// Obvious disadvantage of current approach is not clear relation between hook and
// observer itself: target observed in one place, callback is set in another one + requirement to use data-alert-id
// but so far it seems to be more performant and clear in terms of implementation
// if any constraints is not satisfactory anymore check
// https://github.com/thebuilder/react-intersection-observer

// Should be called before setting targets using useInView
export const createObserver = (id: ObserverId, callback: IntersectionObserverCallback) => {
	if (!observers[id]) {
		observers[id] = new IntersectionObserver(callback, ObserverOptions[id]);
	}
	return observers[id];
};

function useInView(elementRef: RefObject<Element>, observerId: ObserverId, skip = false) {
	useEffect(() => {
		const { current } = elementRef;
		if (skip || !observers[observerId]) {
			return noop;
		}
		observers[observerId].observe(current);
		return () => {
			if (observers[observerId]) {
				observers[observerId].unobserve(current);
			}
		};
	}, [observerId, skip, elementRef]);
}

export default useInView;
